import type { TLessonBase } from '@onesource/schemas';
import { useNavigate } from '@tanstack/react-router';
import { useCallback } from 'react';

import { lessonLink } from '../utils/content-urls';
import { useContentRouteOptional } from './use-content-route';

/**
 * Open a lesson of the current module. Goes straight to the slug URL, so the
 * program menu stays in place. The legacy id URL (which waits for an API call,
 * then redirects) is only used when the lesson has no slug.
 */
export const useOpenLesson = (parentSpaceId: string, moduleId: string) => {
  const navigate = useNavigate();
  const contentRoute = useContentRouteOptional();
  const programSlug = contentRoute?.programSlug;
  const moduleSlug = contentRoute?.subSpaceSlug;

  return useCallback(
    (lesson: Pick<TLessonBase, 'id' | 'urlSlug'>) => {
      if (programSlug && moduleSlug && lesson.urlSlug) {
        navigate(lessonLink(programSlug, moduleSlug, lesson.urlSlug));
        return;
      }
      navigate({ to: `/community-hub/spaces/${parentSpaceId}/modules/${moduleId}/lessons/${lesson.id}` });
    },
    [navigate, programSlug, moduleSlug, parentSpaceId, moduleId],
  );
};
